import { useRef } from 'react';
import { MdOutlinePrint } from 'react-icons/md';
import { BatchCollect } from 'types';
import { Print, PrintTemplate, Text } from 'components';
import { formatTimestamp } from 'helpers';
import { FontSize } from 'commons';
import * as S from './styles';

interface Props {
  historyData: BatchCollect;
}

export function History({ historyData }: Props) {
  const togglePrintRef = useRef<HTMLLabelElement>(null);

  function togglePrint() {
    const { current } = togglePrintRef;

    if (current) {
      current.click();
    }
  }

  const { carrier, consignments, cpf, date, name } = historyData;
  const { day, month, hour, minute } = formatTimestamp(date);

  return (
    <S.HistoryCard key={date.toString()}>
      <Print
        linkTemplate
        Template={
          <PrintTemplate.CollectReceipt
            name={name}
            cpf={cpf}
            collector={carrier}
            batchCollectConsignments={consignments}
            collectionDate={date}
          />
        }
      >
        <label hidden ref={togglePrintRef} />
      </Print>
      <S.TextWrapper>
        <Text size={FontSize.font10}>Realizada por: {name}</Text>

        <Text size={FontSize.font10}>
          Coletado em {day}/{month} ás {hour}h{minute}
        </Text>
        <S.PrintButton onClick={togglePrint}>
          <div className="icon">
            <MdOutlinePrint size={14} />
          </div>

          <Text size={FontSize.font10}>Imprimir</Text>
        </S.PrintButton>
      </S.TextWrapper>
    </S.HistoryCard>
  );
}
